<div class="team-card-container">
    <div class="team-card-progress-container">
        <div fxLayout="column" fxLayout.gt-md="row" class="team-card-progress p-16">
            <div fxLayout="column" fxLayout.gt-xs="row" [fxFlex.gt-md]="team.charts.length ? '1 0 calc(60% - 12px)' : '1 0 calc(40% - 32px)'">
                <div
                    fxLayout="column"
                    fxLayoutAlign="space-between flex-start"
                    fxFlex.gt-xs="1 0 calc(40% - 12px)"
                    class="mb-12 mr-12 team-info-container no-margin-bottom"
                    [class.no-margin-right]="isTeamMembership"
                >
                    <div class="w-100-p">
                        <div fxLayout="row" fxLayoutAlign="space-between">
                            <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-12 ellipsis-container" fxFlex="70%">
                                <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                    <mat-icon svgIcon="team"></mat-icon>
                                </div>

                                <div fxLayout="column" class="ellipsis-container">
                                    <h3 class="m-0">{{ team.name }}</h3>
                                    <span class="breadcrumb ellipsis-container" matTooltip="{{ team.breadcrumbs }}" matTooltipPosition="right">
                                        {{ team.breadcrumbs }}
                                    </span>
                                </div>
                            </div>

                            <div fxFlex="30%" fxLayoutAlign="flex-end">
                                <div fxLayout="row" (click)="getTeamWatchers(team.id, menuTrigger); $event.preventDefault()" class="pointer mr-8">
                                    <app-white-button
                                        [icon]="'visibility'"
                                        [label]="team.watcherCount"
                                        class="no-pointer-events see-more mr-8"
                                        aria-label="See watchers"
                                        #menuTrigger="matMenuTrigger"
                                        [matMenuTriggerFor]="seeWatchers"
                                    >
                                    </app-white-button>
                                </div>

                                <mat-menu #seeWatchers="matMenu" class="watchers-menu" xPosition="before">
                                    <div fxLayout="column" *ngIf="(teamService.teamWatchers$ | async).length; else noTeamWatchers">
                                        <button mat-menu-item aria-label="add" (click)="stopWatchingTeam(team)" *ngIf="team.isCurrentUserWatcher">
                                            <mat-icon class="mr-8">visibility_off</mat-icon>
                                            <span>{{ 'TEAMS.WATCHER.BUTTON.STOP_WATCHING' | translate }}</span>
                                        </button>

                                        <span class="px-16 pt-12 pb-8 font-medium">{{ 'TEAMS.WATCHER.TITLE.PLURAL' | translate }}</span>

                                        <div
                                            mat-menu-item
                                            (click)="$event.stopPropagation()"
                                            fxLayout="row"
                                            fxLayoutAlign="space-between center"
                                            *ngFor="let teamWatcher of teamService.teamWatchers$ | async"
                                        >
                                            <div fxLayout="row" fxLayoutAlign="flex-start center">
                                                <img
                                                    class="avatar pointer"
                                                    *ngIf="teamWatcher.avatar.src; else initials"
                                                    [alt]="teamWatcher.fullName"
                                                    [src]="teamWatcher.avatar.src"
                                                />
                                                <ng-template #initials>
                                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ teamWatcher.fullName | initials }}</div>
                                                </ng-template>
                                                <span class="m-0">{{ teamWatcher.fullName }}</span>
                                            </div>
                                            <mat-icon
                                                class="mr-0 remove-icon"
                                                (click)="openRemoveTeamWatcherDialog(teamWatcher, team); menuTrigger.closeMenu()"
                                                *ngIf="team.isCurrentUserLeader"
                                                >close</mat-icon
                                            >
                                        </div>
                                    </div>

                                    <ng-template #noTeamWatchers>
                                        <div fxLayout="column" fxLayoutAlign="center center">
                                            <mat-icon class="participant-view-illustration" svgIcon="members_illustration"> </mat-icon>
                                            <p class="mt-8 mb-12">
                                                {{ 'TEAMS.WATCHER.LABEL.NO_WATCHERS_YET' | translate }}
                                            </p>
                                        </div>
                                    </ng-template>
                                    <button mat-menu-item aria-label="add" (click)="openAddUserToTeamDialog(team, UserTeamRoleEnum.WATCHER)" *ngIf="team.isCurrentUserLeader">
                                        <mat-icon class="mr-8">add</mat-icon>
                                        <span>{{ 'TEAMS.WATCHER.BUTTON.ADD_WATCHER' | translate }}</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>

                        <div class="mb-24">
                            <span>{{ team.memberCount }} {{ (team.memberCount > 1 ? 'TEAMS.MEMBER.PLURAL' : 'TEAMS.MEMBER.SINGULAR') | translate }}</span>
                        </div>

                        <div class="mb-44" fxLayout="column" fxLayoutAlign="flex-start">
                            <span class="mb-12">{{ 'TEAMS.LEAD.LABEL.LEADS' | translate }}</span>

                            <div fxLayout="row" *ngIf="team.leaders.length; else noLeads">
                                <div *ngFor="let user of team.leaders" class="relative user-details-card-container">
                                    <div #userAvatar class="pointer">
                                        <img class="avatar mr-4" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                        <ng-template #initials>
                                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                        </ng-template>
                                        <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                                    </div>
                                    <app-user-details-card [user]="user" [target]="userAvatar" [isTitleClickable]="false" openedFrom="team_admin_space"></app-user-details-card>
                                </div>
                            </div>
                            <ng-template #noLeads>&#8212;</ng-template>
                        </div>
                    </div>

                    <app-white-button *ngIf="!isTeamMembership" [label]="'GENERAL.BUTTON.SEE_MORE'" (onClick)="navigateToTeamDetailsPage(team.id)"></app-white-button>
                </div>

                <mat-card
                    appearance="outlined"
                    fxLayout="row"
                    fxLayoutAlign="flex-start space-between"
                    fxFlex.gt-xs="1 0 calc(18% - 12px)"
                    class="p-0 mb-12 team-progress-card-container course-completion-state mat-elevation-z0 no-margin-bottom"
                    *ngIf="team.charts.length && !isTeamMembership"
                >
                    <app-course-completion class="w-100-p" [charts]="team.charts"></app-course-completion>
                </mat-card>
            </div>

            <div
                fxLayout="column"
                fxLayoutAlign="flex-start space-between"
                [fxFlex.gt-md]="!isTeamMembership && !team.charts.length ? '1 0 calc(52% - 12px)' : '1 0 calc(18% - 12px)'"
                *ngIf="!isTeamMembership"
            >
                <div fxLayout="column" fxFlex="1 0 100%" *ngIf="team.charts.length; else noTeamProgress">
                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="0 1 100%"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0"
                    >
                        <app-active-days class="w-100-p" [team]="team"></app-active-days>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="0 1 100%"
                        class="p-0 team-progress-card-container mat-elevation-z0"
                    >
                        <app-average-learning-time class="w-100-p" [horizontalView]="true" [avgLearningTime]="team.avgLearningTime"></app-average-learning-time>
                    </mat-card>
                </div>

                <ng-template #noTeamProgress>
                    <div class="no-team-progress p-12 w-100-p" fxLayout="column" fxLayoutAlign="start space-between" fxFlex.gt-md="1 0 100%">
                        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="center center" fxFlex="1 0 100%">
                            <mat-icon class="participant-view-illustration" svgIcon="team_progress_illustration"></mat-icon>
                            <div fxLayout="column" class="no-team-progress-description">
                                <h3 class="mt-8 mb-4">{{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}</h3>
                                <p class="mt-0 mb-16">
                                    {{
                                        (team.isCurrentUserLeader ? 'TEAMS.TEAM_PROGRESS.LABEL.ADD_MEMBERS_TO_SEE_PROGRESS' : 'TEAMS.TEAM_PROGRESS.LABEL.SHOW_PROGRESS') | translate
                                    }}
                                </p>
                            </div>
                            <div fxLayoutAlign="end start" fxFlex="none">
                                <app-flat-button
                                    [icon]="'add'"
                                    [label]="'TEAMS.MEMBER.BUTTON.ADD_MEMBER'"
                                    (onClick)="openAddUserToTeamDialog(team, UserTeamRoleEnum.MEMBER)"
                                    *ngIf="team.isCurrentUserLeader"
                                ></app-flat-button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
